import { lazy } from "react";
const ElBoard = lazy(() => import("app/pages/energy-label/ElBase"));

export const elRouter: any = [
  { path: "/el/board", element: <ElBoard /> },
];
